// src/components/Contact.js

import React from "react";

export default function Contact() {
  return (
    <section id="contact" className="relative">
      <div className="container px-5 py-10 mx-auto flex sm:flex-nowrap flex-wrap">
        <div className="lg:w-2/3 md:w-1/2 bg-gray-900 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
          <iframe
            width="100%"
            height="100%"
            title="map"
            className="absolute inset-0"
            frameBorder={0}
            marginHeight={0}
            marginWidth={0}
            style={{ filter: "opacity(0.7)" }}
            src="https://www.google.com/maps/embed/v1/place?q=Questrom+School+Boston+University+&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
          />
          <div className="bg-gray-900 relative flex flex-wrap py-6 rounded shadow-md">
            <div className="lg:w-1/2 px-6">
              <h2 className="title-font font-semibold text-white tracking-widest text-xs">
                ADDRESS
              </h2>
              <p className="mt-1">
              595 Commonwealth Avenue. <br />
              Boston, MA 02215
              </p>
            </div>
            <div className="lg:w-1/2 px-6 mt-4 lg:mt-0">
              <h2 className="title-font font-semibold text-white tracking-widest text-xs">
                EMAIL
              </h2>
              <a href="mailto:sampom100@gmail.com" className="text-indigo-400 leading-relaxed">
                sam@sampomerantz.me
              </a>
              <h2 className="title-font font-semibold text-white tracking-widest text-xs mt-4">
                PHONE
              </h2>
              <p className="leading-relaxed">(312) 927-2400</p>
            </div>
          </div>
        </div>
        <form
          netlify
          name="contact"
          className="lg:w-1/3 md:w-1/2 flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0">
          <h2 className="text-white sm:text-4xl text-3xl mb-1 font-medium title-font">
            Contact Me
          </h2>
          <p className="leading-relaxed mb-5">
            Social Media:
          </p>
          <a className="text-indigo-400 leading-relaxed mb-5" href="https://www.linkedin.com/in/pomerantzsam/" target="_blank">🔗 LinkedIn</a>
          <a className="text-indigo-400 leading-relaxed mb-5" href="https://www.canvas.com/app/profile/sam-pomerantz" target="_blank">🔗 Canvas</a>
          <a className="text-indigo-400 leading-relaxed mb-5" href="https://github.com/SamPom100/" target="_blank">🔗 GitHub</a>
          <a className="text-indigo-400 leading-relaxed mb-5" href="https://www.instagram.com/sampom100/" target="_blank">🔗 Instagram</a>

          
          <p className="text-indigo-400 leading-relaxed mb-5">
          <a href="https://sampom100.github.io/sampomerantz/" target="_blank">Click here for old website</a>
          </p>
          
        </form>
      </div>
    </section>
  );
}